import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../service/user.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private userService: UserService,
    private route: ActivatedRoute) { }


  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let user: any = JSON.parse(localStorage.getItem('currentUser' + '_' + environment.NOMBRE_EMPRESA));
    // let id = next.params.id;
    // console.log(next);
    // return true;
    if (user != undefined) {


      this.router.navigate(['/default']);
      return false;

    } else {
      return true;
    }
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    let user: any = JSON.parse(localStorage.getItem('currentUser' + '_' + environment.NOMBRE_EMPRESA));
    let band = false;
    if (user != undefined) {

      switch (user.Rol) {

        case environment.ROL.ADMIN:
          if (state.url === '/default' || state.url === '/default/empresa' || state.url === '/default/solicitar-servicio' || state.url === '/default/metodo-pago' || state.url === '/default/reporte-aprobacion' || state.url === '/default/codigo-promocional') {
            this.router.navigate(['/default/usuarios']);
            band = false;
          } else {
            band = true;
          }
          break;
         

        case environment.ROL.CORPORATIVO:

          if (state.url === '/default/usuarios' || state.url === '/default/reporte-aprobacion' || state.url === '/default/empresa' || state.url === '/default/centro-costo' || state.url === '/default/empresas' || state.url === '/default/sedes') {
            this.router.navigate(['/default']);
            band = false;
          } else {
            band = true;
          }
          break;
        case environment.ROL.PARTICULAR:
          //   console.log(state.url);
          if (state.url === '/default/empresa' || state.url === '/default/usuarios' || state.url === '/default/reporte-empresarial' || state.url === '/default/reporte-aprobacion' || state.url === '/default/empresas' || state.url === '/default/sedes' || state.url === '/default/centro-costo') {
            //  console.log('false');
            this.router.navigate(['/default']);
            band = false;
          } else {
            band = true;
          }
          break;

        case environment.ROL.ASISTENTE_CORPORATIVO:
          if (state.url === '/default/empresas' || state.url === '/default/usuarios' || state.url === '/default/reporte-empresarial' || state.url === '/default/reporte-aprobacion' || state.url === '/default/sedes' || state.url === '/default/codigo-promocional' || state.url === '/default/centro-costo') {
            this.router.navigate(['/default']);
            band = false;
          } else {
            band = true;
          }
          break;
          case environment.ROL.ADMIN_CORPORATIVO:
          if (state.url === '/default/empresas'  || state.url === '/default/reporte-aprobacion' || state.url === '/default/sedes' || state.url === '/default/codigo-promocional' ) {
            this.router.navigate(['/default']);
            band = false;
          } else {
            band = true;
          }
          break;
          
        case environment.ROL.SUPERVISOR:
          if ( state.url === '/default/centro-costo' || state.url === '/default/metodo-pago' || state.url === '/default/empresa' || state.url === '/default/empresas' || state.url === 'default/sedes') {
            this.router.navigate(['/default']);
            band = false;
          } else {
            band = true;
          }
          break;
        case environment.ROL.OWNER:
          if (state.url == '/default'|| state.url === '/default/solicitar-servicio') {
            this.router.navigate(['/default/configuracion-parametros']);
            band = false;
          } else {
            band = true;
          }
          
          break;
        case environment.ROL.CORPOREAD:
          if (state.url === '/default/usuarios' || state.url === '/default/reporte-aprobacion' || state.url === '/default/empresa' || state.url === '/default/centro-costo' || state.url === '/default/empresas' || state.url === '/default/sedes') {
            this.router.navigate(['/default']);
            band = false;
          } else {
            band = true;
          }
          break;
        default:
          this.router.navigate(['/']);
          band = true;
          break;
      }
    } else {
      this.router.navigate(['/']);
    }
    return band;
  }
}
